import React, { useState, useEffect } from 'react';
import api from '../config/api';
import PageNavbar from './PageNavbar';
import './Flavours.css';

const Flavours = () => {
  const [flavours, setFlavours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [newName, setNewName] = useState('');

  const fetchFlavours = async () => {
    try {
      const response = await api.get('/users/flavours/list');
      setFlavours(response.data.flavours || []);
    } catch (error) {
      console.error('Error fetching flavours:', error);
      setFlavours([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFlavours();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = newName.trim();
    if (!trimmed) {
      alert('Enter a flavour name');
      return;
    }
    try {
      await api.post('/users/flavours', { name: trimmed });
      setNewName('');
      setShowForm(false);
      fetchFlavours();
      alert('Flavour added. It will appear in the cake flavour list when creating orders.');
    } catch (error) {
      alert(error.response?.data?.error || 'Failed to add flavour');
    }
  };

  return (
    <div className="flavours-page">
      <PageNavbar />
      <div className="container">
        <div className="flavours-header">
          <h1>Cake Flavours</h1>
          <button
            className="btn btn-primary"
            onClick={() => {
              setShowForm(!showForm);
              if (showForm) setNewName('');
            }}
          >
            {showForm ? 'Cancel' : 'Add Flavour'}
          </button>
        </div>

        {showForm && (
          <div className="card">
            <h2>Add New Flavour</h2>
            <p className="flavours-hint">New flavours will appear in the order form when adding cakes.</p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Flavour name *</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g. MANGO CREAM"
                  value={newName}
                  onChange={(e) => setNewName(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary">Add Flavour</button>
            </form>
          </div>
        )}

        {loading ? (
          <div className="loading">Loading flavours...</div>
        ) : (
          <div className="card">
            <h2>Current flavours</h2>
            <p className="flavours-hint">Users can select from this list (or type &quot;Others&quot;) when creating cake orders.</p>
            {flavours.length === 0 ? (
              <p className="no-data">No flavours in the list. Run the seed script first: <code>node database/run_seed_flavours.js</code></p>
            ) : (
              <ul className="flavours-list">
                {flavours.map((f) => (
                  <li key={f.id}>{f.name}</li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Flavours;
